export const ENABLE_REDUX_DEVTOOLS =
  process.env.NODE_ENV === "development" &&
  // @ts-ignore
  Boolean(window?.["__REDUX_DEVTOOLS_EXTENSION__"]);
